// extracted by mini-css-extract-plugin
export default {"dayHeader":"DayHeader_dayHeader__Wc+Vm","subtext":"DayHeader_subtext__l1j0J","right":"DayHeader_right__lVTsw"};